/** "$1,200", rounded to whole dollars, like the mock. */
export function money(value: number | null | undefined): string {
  return "$" + Math.round(Number(value) || 0).toLocaleString("en-US");
}

export function wordCount(text: string | null | undefined): number {
  return (text || "").trim().split(/\s+/).filter(Boolean).length;
}

/** "3 Oct 2026". */
export function shortDate(value: string | Date | null | undefined): string {
  if (!value) return "";
  return new Date(value).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/** Empty input is null, anything else a number (NaN becomes null). */
export function numberOrNull(value: string): number | null {
  if (!value.trim()) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/** Only http(s) links are ever rendered as <a href>, so a stored `javascript:` URL can't run. */
export function safeHref(url: string | null | undefined): string | undefined {
  return url && /^https?:\/\//i.test(url) ? url : undefined;
}

/** "25 Sept" this year, "25 Sept 2025" otherwise: for tight table cells. */
export function compactDate(value: string | Date | null | undefined): string {
  if (!value) return "";
  const date = new Date(value);
  const sameYear = date.getFullYear() === new Date().getFullYear();
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    ...(sameYear ? {} : { year: "numeric" }),
  });
}
